import type { ThemeConfig } from 'antd';

const theme: ThemeConfig = {
  token: {
    fontFamily: "Roboto",
    fontSize: 14,
    colorPrimary: '#0c68e9',
  },

  components: {
    Table: {
      cellPaddingBlock: 9,
      cellPaddingInline: 9,
      headerBg: '#F4F6F8',
      headerColor: '#637381',
      rowHoverBg: "#e6f7ff",
      borderRadiusLG: 16,
    },
    Menu: {
      itemHeight: 44,
      itemColor: '#637381',
      itemSelectedBg: '#0C68E914',
      itemSelectedColor: '#0C68E9',
      subMenuItemBg: 'transparent',
      subMenuItemSelectedColor: '#0C68E9',
    },
    Card: {
      borderRadiusLG: 16,
    },
    Button: {
      borderRadius: 8,
    },
    TreeSelect: {
      nodeSelectedBg: '#0C68E9',
      nodeSelectedColor: '#ffffff',
    },
    Select: {
      borderRadius: 8,
    },
    Modal: {
      borderRadiusLG: 16,
      borderRadius: 16,
    },
  },
};

export default theme;
